export default __webpack_public_path__ + "static/media/rabbit.b84b6318.svg";